import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import DashboardScreen from "../modules/shift-module/screens/dashboard-screen";
import AppHeader from "../modules/common-module/component";
import Login from "../modules/auth-module/screens/login";
import {
  clearAll,
  getCookie,
  getData,
  getJsonData,
} from "../../../shared/utils";
import { displayOverlayLoading } from "../feature/common-slice";
import { useSelector, useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import RouteService from "./service";
import { useTranslation } from "react-i18next";
import config from "../../../environments/env-config";
import MyShiftScreen from "../modules/shift-module/screens/myshift-screen";
import ProtectedRoute from "../../../shared/cmn/protected-route";
import { getUserDetails, setAuthDetails, setAuthToken } from "../../../shared/slices";
import { changeThemee } from "../../../shared/utils/theming";


const AppRoutes = () => {
  const dispatchRed = useDispatch();
  const userDetail = useSelector(getUserDetails);

  const authToken = getCookie(config.auth_token);

  const { i18n } = useTranslation();

  

  const { mutate: getTranslation, isLoading: isTransLoading } = useMutation({
    mutationFn: RouteService.getTranslation,
    onSuccess: (translationData) => {
      const { data } = translationData || {};
      i18n.addResourceBundle("de", "translation", data, true);
      i18n.changeLanguage("de");
    },
  });

  const InitTranslation = async () => {
    const english_lan = await getData("tf");
    if (!english_lan) {
      getTranslation();
    }
  };

  const { mutate: getUserData, isLoading: isUserDetailLoading } =
    useMutation({
      mutationFn: RouteService.getUserDetails,
      onSuccess: (data) => {
        
        changeThemee();
        if (data?.data?.jwt_token) setDetailToRedcer(data.data);
      },
    });

  const setDetailToRedcer = async (data: any) => {
    dispatchRed(setAuthDetails(data));
  };

  const checkIsUserDataAvailable = async () => {
    if (authToken) {
      dispatchRed(setAuthToken(authToken));
      getUserData();
    }
    if (!authToken) {
      clearAll();
    }
  };

  useEffect(() => {
    !!authToken && InitTranslation();
    checkIsUserDataAvailable();
  }, []);

  useEffect(() => {
    if (isUserDetailLoading || isTransLoading) {
      dispatchRed(displayOverlayLoading(2));
    } else {
      dispatchRed(displayOverlayLoading(0));
    }
  }, [isUserDetailLoading, isTransLoading]);

  if (!userDetail?.type) {
    return null; 
  }

  return (
    <>
      {authToken ? (
        <>
          <AppHeader />
          {userDetail.type === "1" ? (
            <Routes>
              <Route path="/" element={<DashboardScreen />}></Route>
              <Route path="*" element={<DashboardScreen />}></Route>
              <Route path="/dashboard" element={<DashboardScreen />}></Route>
              <Route path="/myshift" element={<MyShiftScreen />}></Route>
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={<MyShiftScreen />}></Route>
              <Route path="*" element={<MyShiftScreen />}></Route>
              <Route path="/myshift" element={<MyShiftScreen />}></Route>
            </Routes>
          )}
        </>
      ) : (
        <Routes>
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <Login />
              </ProtectedRoute>
            }
          ></Route>
        </Routes>
      )}{" "}
    </>
    // <>
    //   <>
    //     {/* <AppHeader />
    //     <Routes>
    //       <Route path="/" element={<DashboardScreen />}></Route>
    //     </Routes> */}
    //   </>
    //   <>
    //     <Routes>
    //       <Route path="/" element={<Login />}></Route>
    //     </Routes>
    //   </>
    // </>
  );
};
export default AppRoutes;
